import React from "react";
import NamedResourceForm from "../../curriculum/components/named-resource-form";
import {cvPositionService} from "../../../services/curriculum-resource-service";

const fields = [
    {name: "name", label: "Nome *", col: "col-span-12"},
];

const CvPositionForm = () => (
    <NamedResourceForm singularTitle="Cargo" article="o" basePath="/cv/position"
                       queryKey="cv-positions" service={cvPositionService} fields={fields}/>
);

export default CvPositionForm;
